import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App/App';
import { YMInitializer } from 'react-yandex-metrika';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <YMInitializer accounts={[95940102]}/>
    <App />
  </React.StrictMode>
);
